var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunScrollBaseElement_check;
import { adoptedStyle, state } from '@mantou/gem/lib/decorators';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { DuoyunResizeBaseElement } from './resize';
const PIXEL_DEVIATION = 0.1;
const style = createCSSSheet(css `
  :host {
    display: block;
    overflow: auto;
    scrollbar-width: none;
    overscroll-behavior: contain;
    --mask-width: 1.5em;
    --mask-top: 0;
    --mask-right: 100%;
    --mask-bottom: 100%;
    --mask-left: 0;
    --mask-dir: bottom;
    --mask-start: var(--mask-top);
    --mask-end: var(--mask-bottom);
  }
  :host(:where(:--top-overflow, [data-topoverflow])) {
    --mask-top: var(--mask-width);
  }
  :host(:where(:--bottom-overflow, [data-bottomoverflow])) {
    --mask-bottom: calc(100% - var(--mask-width));
  }
  :host(:where(:--left-overflow, [data-leftoverflow], :--right-overflow, [data-rightoverflow])) {
    --mask-dir: right;
    --mask-start: var(--mask-left);
    --mask-end: var(--mask-right);
  }
  :host(:where(:--left-overflow, [data-leftoverflow])) {
    --mask-left: var(--mask-width);
  }
  :host(:where(:--right-overflow, [data-rightoverflow])) {
    --mask-right: calc(100% - var(--mask-width));
  }
  :host(
      :where(
          :--top-overflow,
          [data-topoverflow],
          :--bottom-overflow,
          [data-bottomoverflow],
          :--left-overflow,
          [data-leftoverflow],
          :--right-overflow,
          [data-rightoverflow]
        )
    ) {
    --m: linear-gradient(to var(--mask-dir), #fff0, #000 var(--mask-start), #000 var(--mask-end), #fff0 100%);
    -webkit-mask-image: var(--m);
    mask-image: var(--m);
  }
`);
let DuoyunScrollBaseElement = class DuoyunScrollBaseElement extends DuoyunResizeBaseElement {
    constructor(options) {
        super(options);
        _DuoyunScrollBaseElement_check.set(this, () => {
            const contentHeight = this.clientHeight - (this.borderBoxSize.blockSize - this.contentRect.height);
            const contentWidth = this.clientWidth - (this.borderBoxSize.inlineSize - this.contentRect.width);
            const scrollHeight = this.scrollHeight;
            const scrollWidth = this.scrollWidth;
            const scrollTop = this.scrollTop;
            const scrollBottom = scrollHeight - contentHeight - scrollTop;
            const scrollLeft = this.scrollLeft;
            const scrollRight = scrollWidth - contentWidth - scrollLeft;
            this.topOverflow = scrollTop > PIXEL_DEVIATION;
            this.rightOverflow = scrollRight > PIXEL_DEVIATION;
            this.bottomOverflow = scrollBottom > PIXEL_DEVIATION;
            this.leftOverflow = scrollLeft > PIXEL_DEVIATION;
        });
        this.addEventListener('scroll', __classPrivateFieldGet(this, _DuoyunScrollBaseElement_check, "f"));
        this.effect(() => {
            __classPrivateFieldGet(this, _DuoyunScrollBaseElement_check, "f").call(this);
        });
    }
};
_DuoyunScrollBaseElement_check = new WeakMap();
__decorate([
    state
], DuoyunScrollBaseElement.prototype, "topOverflow", void 0);
__decorate([
    state
], DuoyunScrollBaseElement.prototype, "rightOverflow", void 0);
__decorate([
    state
], DuoyunScrollBaseElement.prototype, "bottomOverflow", void 0);
__decorate([
    state
], DuoyunScrollBaseElement.prototype, "leftOverflow", void 0);
DuoyunScrollBaseElement = __decorate([
    adoptedStyle(style)
], DuoyunScrollBaseElement);
export { DuoyunScrollBaseElement };
//# sourceMappingURL=scroll.js.map